import { render } from "./delegationSunset.vue?vue&type=template&id=6ca73ceb&scoped=true"
import script from "./delegationSunset.vue?vue&type=script&lang=ts"
export * from "./delegationSunset.vue?vue&type=script&lang=ts"

import "./delegationSunset.vue?vue&type=style&index=0&id=6ca73ceb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ca73ceb"

export default script